import { render, staticRenderFns } from "./ServiceFeeManagement.vue?vue&type=template&id=12bc9a2b&scoped=true"
import script from "./ServiceFeeManagement.vue?vue&type=script&lang=js"
export * from "./ServiceFeeManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceFeeManagement.vue?vue&type=style&index=0&id=12bc9a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc9a2b",
  null
  
)

export default component.exports